export enum TcListRowActionButtonsPosition {
  BeforeData = 'left',
  AfterData = 'right',
}
